import {
  CREATIVE_NOTIFICATION_CHANNEL_MESSAGE,
  CreativeNotificationChannelMessage
} from 'common/creative-notification-channel/protocol';

export class FormatNotifier {
  constructor(private readonly aWindow: Window) {}

  notify(event: string): void {
    const message: CreativeNotificationChannelMessage = {
      type: CREATIVE_NOTIFICATION_CHANNEL_MESSAGE,
      event
    };
    try {
      this.aWindow.parent.postMessage(message, '*'); // NOSONAR: an opaque origin cannot be named as a target
    } catch (e) {
      // A detached frame has no host left to tell.
    }
  }
}
